import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  billInvoices: [],
  loading: false,
  error: null,
  pagination: {
    totalPages: 0,
    totalElements: 0,
    currentPage: 0,
    pageSize: 10,
    isLastPage: false,
    isFirstPage: true,
  },
  selectedBill: null,
};

const billInvoiceSlice = createSlice({
  name: "billInvoice",
  initialState,
  reducers: {
    fetchBillInvioceStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchBillInvoiceSuccess(state, action) {
      state.billInvoices = action.payload.billInvoices;
      state.pagination = action.payload.pagination;
      state.loading = false;
      state.error = null;
    },
    fetchBillInvoiceFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },

    fetchBillInviocePDFStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchBillInvoicePDFSuccess(state, action) {
      state.loading = false;
      state.error = null;
    },
    fetchBillInvoicePDFFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },

    addBillInvoiceStart(state) {
      state.loading = true;
      state.error = null;
    },
    addBillInvoiceSuccess(state, action) {
      state.loading = false;
      state.billInvoices.unshift(action.payload);
      state.error = null;
    },
    addBillInvioceFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },

    addNoteStart(state) {
      state.loading = true;
      state.error = null;
    },
    addNoteSuccess(state, action) {
      state.loading = false;
      state.error = null;
    },
    addNoteFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },

    deleteBillInvoiceStart(state) {
      state.loading = true;
      state.error = null;
    },
    deleteBillInvoiceSuccess(state, action) {
      state.loading = false;
      state.billInvoices = state.billInvoices.filter(
        (invioce) => invioce.id !== action.payload
      );
      state.error = null;
    },
    deleteBillInvoicepFailure(state, action) {
      state.loading = true;
      state.error = action.payload;
    },
    editBillInvoiceStart(state) {
      state.loading = true;
      state.error = null;
    },
    editBillInvoiceSuccess(state, action) {
      state.loading = false;
      const updatedInvoice = action.payload;
      const index = state.billInvoices.findIndex(
        (billInvoice) => billInvoice.id === updatedInvoice.id
      );
      if (index !== -1) {
        state.billInvoices[index] = updatedInvoice;
      }
      state.error = null;
    },
    editBillInvoiceFailure(state, action) {
      state.loading = true;
      state.error = action.payload;
    },

    editBillInvoiceStatusStart(state) {
      state.loading = true;
      state.error = null;
    },
    editBillInvoiceStatusSuccess(state, action) {
      state.loading = false;

      state.error = null;
    },
    editBillInvoiceStatusFailure(state, action) {
      state.loading = true;
      state.error = action.payload;
    },

    getBillByIdStart(state) {
      state.loading = false;
      state.error = null;
      state.selectedBill = null;
    },
    getBillByIdSuccess(state, action) {
      state.loading = false;
      state.selectedBill = action.payload;
      state.error = null;
    },
    getBillByIdFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    resetBillingInvoice(state) {
      state.billInvoices = [];
      state.loading = false;
      state.error = null;
    },
  },
});

export const {
  addNoteStart,
  addNoteSuccess,
  addNoteFailure,
  editBillInvoiceStatusStart,
  editBillInvoiceStatusSuccess,
  editBillInvoiceStatusFailure,

  fetchBillInvioceStart,
  fetchBillInvoiceSuccess,
  fetchBillInvoiceFailure,
  fetchBillInviocePDFStart,
  fetchBillInvoicePDFSuccess,
  fetchBillInvoicePDFFailure,
  addBillInvoiceStart,
  addBillInvoiceSuccess,
  addBillInvioceFailure,
  deleteBillInvoiceStart,
  deleteBillInvoiceSuccess,
  deleteBillInvoicepFailure,
  editBillInvoiceStart,
  editBillInvoiceSuccess,
  editBillInvoiceFailure,
  getBillByIdStart,
  getBillByIdSuccess,
  getBillByIdFailure,
  resetBillingInvoice,
} = billInvoiceSlice.actions;

export default billInvoiceSlice.reducer;
